import React from "react"
import {FieldEditableMode} from "../../../../proto/render/editable";
import {FieldViewSize} from "../../../../const";
import EditableInput from "../inline-editable/input-component";
import {isBulkSelection} from "../../../../../gd/right-click-menu";
import GoogleApi from "../../../../../gd/api/google-api";
import {FieldInlineEditableProps} from "../../../../render/inline-editable";
import Addresses from "../../../../../model2/address/addresses";
import Location from "../../../../../model2/address/location";
import Address from "../../../../../model2/address/address";

const debug = false
// const debug = "FieldAddress_InlineEditable"

type State = {
    initialPropsValue?  : any
    currentOption?      : Address | null
    showPopover         : boolean
    mode                : FieldEditableMode
    inputValue          : string
    options             : Option[]
}

export default class FieldAddress_InlineEditable extends React.Component<FieldInlineEditableProps, State> {

    constructor(props: FieldInlineEditableProps) {
        super(props);

        const value = this.props.field.getViewValue(this.props.model)

        this.state = {
            currentOption       : value,
            showPopover         : false,
            mode                : FieldEditableMode.VIEW,
            inputValue          : value?.description,
            options             : []
        }
    }

    hidePopover = () => {
        if (this.state.showPopover) {
            this.setState({showPopover: false, mode: FieldEditableMode.VIEW})
        }
    }

    onImmediateChange = async (value: string) => {

        this.setState({inputValue: value});

        if(value?.length > 0){
            this.setState({showPopover: true})
        }
        else{
            this.setState({showPopover: false})
        }

        try{
            const response: any = await GoogleApi.searchPlaces(this.state.inputValue)

            debug && console.log(debug, "Response?", response)

            const addressCollection = Addresses.initFromJson(response?.suggestions)

            this.setState({options: addressCollection.toOptions()})
        }
        catch(e){
            console.error(e)
        }
    };

    onMouseEnter = () => {
        if (this.props.disabled || !this.props.field.canEdit(this.props.model)) return false

        this.setState({mode: FieldEditableMode.HOVERED})
    }

    onMouseLeave = () => {
        this.setState({mode: FieldEditableMode.VIEW})
    }

    onBlur = ()=>{

        if(!this.state.showPopover || this.state.options.length === 0){
            this.setState({mode: FieldEditableMode.VIEW})
        }
    }

    onClick = (e: React.MouseEvent) => {

        if (this.props.disabled || !this.props.field.canEdit(this.props.model)) return false

        this.setState({mode: FieldEditableMode.EDITING})
    }

    onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()

        this.onChange(null)
    }

    onChange = (newValue: Address | null) => {

        this.setState({currentOption: newValue})

        this.props.onChange && this.props.onChange(newValue)

        this.setState({mode: FieldEditableMode.VIEW, options: []})

    }

    onOptionClick = async (option: Option)=> {

        try {
            const response = await GoogleApi.getPlaceLocation(option.value.placeId)

            if(option.value.placeId.length > 0){

                option.value.isValid = true
                option.value.location = new Location(response.location)

                this.onChange(option.value)
            }
        } catch (e){
            console.error(e)
        }
    }

    getClasses = ()=>{

        const isSmall = this.props.size === FieldViewSize.SMALL

        // GOTCHA - h-36 / p-l-10 / p-r-10 are !important helpers, so at SMALL they would beat
        // the min-height and padding .ui5-field-editable.size-small sets in field-editable.scss
        // and the field would keep its default box. The size class has to supply the box alone.
        // w-300 goes with them: at this size the container sets the width.
        return  Classes("ui5-field-editable", this.props.className, {
            "h-36 w-300 p-l-10 p-r-10"      : !isSmall,
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : isSmall,
            "size-small"                    : isSmall,
        })
    }

    renderValue = (displayValue: string)=>{
        const showIcon = _.get(this.props.configOptions, 'showIcon', true)

        return (
            <div className="flex-row-left-center txt-truncate w-100-percent">
                {showIcon && displayValue && <div className="i5-location ui5-ico-16 m-r-10"></div>}
                <div className="txt-truncate">
                    {displayValue}
                </div>
            </div>
        )
    }

    renderEditing = () => {
        const value              = this.props.field.getViewValue(this.props.model)
        const displayValue       = this.props.field.getDisplayValue(value)
        const field   = this.props.field
        this.props.field.options = this.state.options

        const isSmall = this.props.size === FieldViewSize.SMALL

        const classes = Classes("ui5-field-form-editable w-100-percent", {
            "h-36"  : !isSmall,
            "h-30"  : isSmall
        })

        return (
            <div className="w-300 max-w-100-percent">
                <EditableInput className         = {classes} // p-l-10 p-r-10
                               inputClassName    = "ui5-txt-default"
                               value             = {displayValue}
                               focusOnMount      = {true}
                               placeholder       = {this.props.field.placeholder}
                               onImmediateChange = {this.onImmediateChange}
                               onBlur            = {this.onBlur}/>
                {this.state.showPopover  && (
                    <field.components.PopoverMenu parent = {this}
                                                  field  = {this.props.field}
                                                  model  = {this.props.model}/>
                )}
            </div>
        )
    }

    renderHovered = () => {

        const hoveredClasses = Classes(this.getClasses(), "is-hovered")

        const value = this.props.field.getViewValue(this.props.model)
        const displayValue = this.props.field.getDisplayValue(value)

        return (
            <div className    = {hoveredClasses}
                 onClick      = {this.onClick}
                 onMouseLeave = {this.onMouseLeave}>

                {this.renderValue(displayValue)}

                <div className="buttons">
                    {!!displayValue && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                </div>
            </div>
        )
    }

    renderView = () => {

        const value         = this.props.field.getViewValue(this.props.model)
        const displayValue  = this.props.field.getDisplayValue(value)

        return (
            <div className={this.getClasses()}
                 onMouseEnter={this.onMouseEnter}
                 onClick={this.onClick}>
                <div className="flex-row-left-center max-w-100-percent">

                    {this.renderValue(displayValue)}

                </div>
            </div>
        )
    }

    render() {

        switch (this.state.mode) {
            case FieldEditableMode.EDITING:
                return this.renderEditing()

            case FieldEditableMode.HOVERED:
                return this.renderHovered()

            case FieldEditableMode.VIEW:
            default:
                return this.renderView()
        }
    }
}
